import { AxiosRequestConfig } from 'axios';
import { getStbClient } from './fetch';

type DownStatus =
  | {
      isDown: true;
      isDownTitle: string;
      isDownMessage: string;
    }
  | {
      isDown: false;
      isDownTitle?: string;
      isDownMessage?: string;
    };

type ServiceStatus = {
  name: string;
  isUnstable: boolean;
  isUnstableTitle: string;
  isUnstableMessage: string;
} & DownStatus;

export type DomainStatusDTO = {
  services: ServiceStatus[];
};

export async function getDowntimeStatus(
  options: AxiosRequestConfig = {}
): Promise<DomainStatusDTO> {
  const client = await getStbClient();

  const response = await client.get(`/open/downtime/status/Claims`, options);

  return response.data;
}
